import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

export interface CloseProjectEvaluationRequest {
  agreementId: number;
}

export class CloseProjectEvaluationUseCase
  implements UseCase<CloseProjectEvaluationRequest, boolean>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(request: CloseProjectEvaluationRequest): Observable<boolean> {
    return this.repo.closeProjectEvaluation(request.agreementId);
  }
}

const closeProjectEvaluationUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new CloseProjectEvaluationUseCase(repo);

export const closeProjectEvaluationUseCaseProvider: Provider = {
  provide: CloseProjectEvaluationUseCase,
  useFactory: closeProjectEvaluationUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
